// TablaCedulas.js

import React, { useState } from "react";
import { differenceInYears, parseISO } from "date-fns";

const TablaCedulas = ({ resultados, onOpenModal }) => {
  const validarRUT = (rutCompleto) => {
    if (!/^0*(\d{1,3}(\.?\d{3})*)\-?([\dkK])$/.test(rutCompleto)) return false;

    rutCompleto = rutCompleto.replace(/\./g, "").toUpperCase();
    let tmp = rutCompleto.split("-");
    let digv = tmp[1];
    let rut = tmp[0];

    let M = 0, S = 1;
    for (; rut; rut = Math.floor(rut / 10))
      S = (S + (rut % 10) * (9 - (M++ % 6))) % 11;

    return S ? S - 1 === parseInt(digv, 10) : "K" === digv;
  };

  const validaFecha = (fecha) => {
    if (!fecha) return false;

    // Normaliza la fecha removiendo espacios extra
    fecha = fecha.trim();

    // Comprueba el formato de la fecha en formato dd-mm-aaaa
    const regex = /^\d{2}-\d{2}-\d{4}$/;

    if (!regex.test(fecha)) return false;

    // Extrae los componentes de la fecha
    const partes = fecha.split('-');
    if (partes.length !== 3) return false;

    let [dia, mes, año] = partes;
    dia = parseInt(dia, 10);
    mes = parseInt(mes, 10);
    año = parseInt(año, 10);

    if (isNaN(dia) || isNaN(mes) || isNaN(año)) return false;

    // Verifica los rangos de día y mes
    if (dia < 1 || dia > 31 || mes < 1 || mes > 12) return false;

    // Verifica el rango del año
    if (año < 1900 || año > new Date().getFullYear()) return false;

    // Verificación adicional para febrero y años bisiestos
    if (mes === 2) {
      const esBisiesto = (año % 4 === 0 && año % 100 !== 0) || año % 400 === 0;
      const maxDia = esBisiesto ? 29 : 28;
      if (dia > maxDia) return false;
    }

    // Verificación para los meses con 30 días
    if ([4, 6, 9, 11].includes(mes) && dia > 30) return false;

    // La fecha es válida
    return true;
  };

  const esFechaMenorAActual = (fecha) => {
    if (!fecha) return false;
    const fechaActual = new Date();
    const partesFecha = fecha.split('-');
    const fechaFormateada = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);
    return fechaFormateada < fechaActual;
  };

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const fechaNac = parseISO(fechaNacimiento); // Convierte la fecha de nacimiento a objeto Date
    return differenceInYears(hoy, fechaNac);
  };

  return (
    <div className="tabla-responsiva">
      <table>
        <thead>
          <tr>
            <th>Nombre Archivo</th> {/* Nueva cabecera */}
            <th>Estado</th> {/* Nueva cabecera para estado */}
            <th>RUN</th>
            <th>Nombres</th>
            <th>Apellidos</th>
            <th>F.Nac</th>
            <th>Nacionalidad</th>
            <th>Sexo</th>
            <th>AFP ✨</th>
            <th>Extranjero</th>
            <th>Visa</th>
            <th>F. Vcto</th>
            <th>Cédula</th>
          </tr>
        </thead>
        <tbody>
          {resultados.map((resultado, index) => {
            const esEstadoListo = resultado.estado === "Listo";
            return (
              <tr
                key={index}
                className={esEstadoListo && (!validarRUT(resultado.RUN) || !validaFecha(resultado.FECHANAC)) ? "fila-invalida" : ""}
              >
                <td data-label="Nombre Archivo">{resultado.archivoName}</td> {/* Nueva celda */}
                <td data-label="Estado">
                  {resultado.estado === "procesando" && (
                    <>
                      Procesando
                      <span className="icono-actualizando"></span>
                    </>
                  )}
                  {resultado.estado === "reintentando" && (
                    <>
                      Reintentando
                      <span className="icono-actualizando"></span>
                    </>
                  )}
                  {resultado.estado === "Listo" && (
                    <>
                      Listo
                      <span className="icono-check">&#10003;</span>
                    </>
                  )}
                  {resultado.estado === "error" && (
                    <>
                      Error
                      <span className="icono-error">&#10060;</span>
                    </>
                  )}
                </td> {/* Nueva celda para estado */}
                <td data-label="RUN" className={esEstadoListo && !validarRUT(resultado.RUN) ? "celda-invalida" : ""}>
                  {resultado.RUN}
                </td>
                <td data-label="Nombre">{resultado.NOMBRES}</td>
                <td data-label="Apellidos">{resultado.APELLIDOS}</td>
                <td
                  data-label="Fecha Nac"
                  className={esEstadoListo && (!validaFecha(resultado.FECHANAC) || calcularEdad(resultado.FECHANAC) < 18) ? "celda-invalida" : ""}
                >
                  {resultado.FECHANAC}
                </td>
                <td data-label="Nacionalidad">{resultado.NACIONALIDAD}</td>
                <td data-label="Sexo">{resultado.SEXO}</td>
                <td data-label="AFP✨" className={esEstadoListo && resultado.AFP=="Sin AFP" ? "celda-invalida" : ""}>
                  {resultado.AFP}
                </td>
                <td data-label="Extranjero">{resultado.EXTRANJERO}</td>
                <td data-label="VISA" className={esEstadoListo && resultado.VISA=="TEMPORARIA" ? "celda-invalida" : ""}>
                  {resultado.VISA}
                </td>
                <td data-label="FECHAVEN" className={esEstadoListo && esFechaMenorAActual(resultado.FECHAVEN) ? "celda-invalida" : ""}>
                  {resultado.FECHAVEN}
                </td>
                <td>
                  <button
                    className="button-table"
                    onClick={() => onOpenModal(resultado, "cedula")}
                  >
                    Ver Cédula
                  </button>
                  {resultado.AFP && resultado.AFP !== "Sin AFP" && (
                    <button
                      className="button-table"
                      onClick={() => onOpenModal(resultado, "imagenAFP")}
                    >
                      Ver AFP
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TablaCedulas;
